import { alpha, lighten, darken, createTheme } from '@mui/material/styles';
import contrast from 'get-contrast';
import deepmerge from 'deepmerge';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React from 'react';
import { ThemeProvider as ThemeProvider$1, CssBaseline, ScopedCssBaseline } from '@mui/material';
import { StylesProvider } from '@mui/styles';
import { ThemeProvider as ThemeProvider$2 } from '@emotion/react';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$e = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$d = fails$e;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString$8 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$8.call(it).slice(8, -1);
};

var fails$c = fails$e;
var classof$6 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$c(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$6(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$4 = function (it) {
  return IndexedObject$2(requireObjectCoercible$5(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$f = function (argument) {
  return typeof argument === 'function';
};

var isCallable$e = isCallable$f;

var isObject$7 = function (it) {
  return typeof it === 'object' ? it !== null : isCallable$e(it);
};

var global$c = global$d;
var isCallable$d = isCallable$f;

var aFunction = function (argument) {
  return isCallable$d(argument) ? argument : undefined;
};

var getBuiltIn$5 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var getBuiltIn$4 = getBuiltIn$5;

var engineUserAgent = getBuiltIn$4('navigator', 'userAgent') || '';

var global$b = global$d;
var userAgent$1 = engineUserAgent;

var process$1 = global$b.process;
var Deno = global$b.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent$1) {
  match = userAgent$1.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$1.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$b = fails$e;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$b(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var isCallable$c = isCallable$f;
var getBuiltIn$3 = getBuiltIn$5;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$3('Symbol');
  return isCallable$c($Symbol) && Object(it) instanceof $Symbol;
};

var tryToString$1 = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$b = isCallable$f;
var tryToString = tryToString$1;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$b(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$2(func);
};

var isCallable$a = isCallable$f;
var isObject$6 = isObject$7;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$6(val = fn.call(input))) return val;
  if (isCallable$a(fn = input.valueOf) && !isObject$6(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$6(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$a = global$d;

var setGlobal$3 = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global$a, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$a[key] = value;
  } return value;
};

var global$9 = global$d;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$9[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var requireObjectCoercible$4 = requireObjectCoercible$6;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return Object(requireObjectCoercible$4(argument));
};

var toObject$5 = toObject$6;

var hasOwnProperty = {}.hasOwnProperty;

var has$9 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$5(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$8 = global$d;
var shared$2 = shared$3.exports;
var has$8 = has$9;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$2 = global$8.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$c = function (name) {
  if (!has$8(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has$8(Symbol$2, name)) {
      WellKnownSymbolsStore[name] = Symbol$2[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$b = wellKnownSymbol$c;

var TO_PRIMITIVE = wellKnownSymbol$b('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};

var global$7 = global$d;
var isObject$4 = isObject$7;

var document$1 = global$7.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$6 = descriptors;
var fails$a = fails$e;
var createElement = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$6 && !fails$a(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$5 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$2 = toPropertyKey$3;
var has$7 = has$9;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$7(O, P)) return createPropertyDescriptor$3(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$3 = isObject$7;

// `Assert: Type(argument) is Object`
var anObject$a = function (argument) {
  if (isObject$3(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$9 = anObject$a;
var toPropertyKey$1 = toPropertyKey$3;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey$1(P);
  anObject$9(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;

var createNonEnumerableProperty$4 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$6 = {exports: {}};

var isCallable$9 = isCallable$f;
var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$9(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$6 = global$d;
var isCallable$8 = isCallable$f;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$6.WeakMap;

var nativeWeakMap = isCallable$8(WeakMap$1) && /native code/.test(inspectSource$2(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$5 = global$d;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var objectHas = has$9;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$5.WeakMap;
var set, get, has$6;

var enforce = function (it) {
  return has$6(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$6 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$6 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$6,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$2 = descriptors;
var has$5 = has$9;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = has$5(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$4 = global$d;
var isCallable$7 = isCallable$f;
var has$4 = has$9;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$1 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;

var getInternalState$1 = InternalStateModule$1.get;
var enforceInternalState = InternalStateModule$1.enforce;
var TEMPLATE = String(String).split('String');

(redefine$6.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$7(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has$4(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
      createNonEnumerableProperty$2(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$4) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$2(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$7(this) && getInternalState$1(this).source || inspectSource$1(this);
});

var objectGetOwnPropertyNames = {};

var ceil$1 = Math.ceil;
var floor$1 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$5 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil$1)(argument);
};

var toInteger$4 = toInteger$5;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$5 = function (argument) {
  return argument > 0 ? min$1(toInteger$4(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$3 = toInteger$5;

var max$1 = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toInteger$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength$4 = toLength$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$4 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength$4(O.length);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$4(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$4(false)
};

var has$3 = has$9;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$3(hiddenKeys$2, key) && has$3(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$3(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$2 = getBuiltIn$5;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$8 = anObject$a;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$2 = has$9;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$2(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$9 = fails$e;
var isCallable$6 = isCallable$f;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$6(detection) ? fails$9(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$3 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var redefine$5 = redefine$6.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$3;
  } else if (STATIC) {
    target = global$3[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$3[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$5(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$1 = descriptors;
var fails$8 = fails$e;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$4 = toObject$6;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$8(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$4(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$1(S).concat(getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$9 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$9({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

var defaultKalturaBreakpoint = {
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1600
};
var breakpoints = function breakpoints(kalturaBreakpoints) {
  return {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
      xs: 0,
      sm: kalturaBreakpoints.sm,
      md: kalturaBreakpoints.md,
      lg: kalturaBreakpoints.lg,
      xl: kalturaBreakpoints.xl
    }
  };
};

var defaultKalturaLightTones = {
  tone1: '#333333',
  tone2: '#707070',
  tone3: '#878787',
  tone4: '#BDBDBD',
  tone5: '#D9D9D9',
  tone6: '#EBEBEB',
  tone7: '#F5F5F5',
  tone8: '#FFFFFF',
  surfaces: {
    background: '#FFFFFF',
    paper: '#F5F5F5',
    elevated: '#FFFFFF',
    protection: '#3D3D3D' // TODO seems to be added by mistake - condsider to remove

  },
  backdrop: {
    color: '#222222',
    opacity: 0.6
  }
};

var defaultFontFamily$1 = "Lato, Helvetica Neue, Segoe UI, sans-serif";
var generateKalturaTypography = function generateKalturaTypography(overrides) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;

  var fontFamily = (overrides === null || overrides === void 0 ? void 0 : overrides.fontFamily) ? overrides.fontFamily : defaultFontFamily$1;
  return {
    fontFamily: fontFamily,
    webFontUrl: '',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    lineHeight: 'auto',
    color: defaultKalturaLightTones.tone1,
    heading1: {
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.0417,
      letterSpacing: "normal",
      fontFamily: ((_a = overrides === null || overrides === void 0 ? void 0 : overrides.heading1) === null || _a === void 0 ? void 0 : _a.fontFamily) ? (_b = overrides === null || overrides === void 0 ? void 0 : overrides.heading1) === null || _b === void 0 ? void 0 : _b.fontFamily : fontFamily,
      topBottomMargins: '2rem'
    },
    heading2: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.0625,
      letterSpacing: "normal",
      fontFamily: ((_c = overrides === null || overrides === void 0 ? void 0 : overrides.heading2) === null || _c === void 0 ? void 0 : _c.fontFamily) ? (_d = overrides === null || overrides === void 0 ? void 0 : overrides.heading2) === null || _d === void 0 ? void 0 : _d.fontFamily : fontFamily,
      topBottomMargins: '1rem'
    },
    heading3: {
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.084,
      letterSpacing: "normal",
      fontFamily: ((_e = overrides === null || overrides === void 0 ? void 0 : overrides.heading3) === null || _e === void 0 ? void 0 : _e.fontFamily) ? (_f = overrides === null || overrides === void 0 ? void 0 : overrides.heading3) === null || _f === void 0 ? void 0 : _f.fontFamily : fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading4: {
      fontWeight: 700,
      fontSize: "1.25rem",
      lineHeight: 1.1,
      letterSpacing: "normal",
      fontFamily: ((_g = overrides === null || overrides === void 0 ? void 0 : overrides.heading4) === null || _g === void 0 ? void 0 : _g.fontFamily) ? (_h = overrides === null || overrides === void 0 ? void 0 : overrides.heading4) === null || _h === void 0 ? void 0 : _h.fontFamily : fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading5: {
      fontWeight: 700,
      fontSize: "1.15rem",
      lineHeight: 1.11,
      letterSpacing: "normal",
      fontFamily: ((_j = overrides === null || overrides === void 0 ? void 0 : overrides.heading5) === null || _j === void 0 ? void 0 : _j.fontFamily) ? (_k = overrides === null || overrides === void 0 ? void 0 : overrides.heading5) === null || _k === void 0 ? void 0 : _k.fontFamily : fontFamily,
      topBottomMargins: '0.25rem'
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.3125,
      letterSpacing: "normal",
      fontFamily: ((_l = overrides === null || overrides === void 0 ? void 0 : overrides.body1) === null || _l === void 0 ? void 0 : _l.fontFamily) ? (_m = overrides === null || overrides === void 0 ? void 0 : overrides.body1) === null || _m === void 0 ? void 0 : _m.fontFamily : fontFamily
    },
    body1Highlight: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: 1.3125,
      letterSpacing: "normal",
      fontFamily: ((_o = overrides === null || overrides === void 0 ? void 0 : overrides.body1Highlight) === null || _o === void 0 ? void 0 : _o.fontFamily) ? (_p = overrides === null || overrides === void 0 ? void 0 : overrides.body1Highlight) === null || _p === void 0 ? void 0 : _p.fontFamily : fontFamily
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.286,
      letterSpacing: "normal",
      fontFamily: ((_q = overrides === null || overrides === void 0 ? void 0 : overrides.body2) === null || _q === void 0 ? void 0 : _q.fontFamily) ? (_r = overrides === null || overrides === void 0 ? void 0 : overrides.body2) === null || _r === void 0 ? void 0 : _r.fontFamily : fontFamily
    },
    body2Highlight: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: 1.286,
      letterSpacing: "normal",
      fontFamily: ((_s = overrides === null || overrides === void 0 ? void 0 : overrides.body2Highlight) === null || _s === void 0 ? void 0 : _s.fontFamily) ? (_t = overrides === null || overrides === void 0 ? void 0 : overrides.body2Highlight) === null || _t === void 0 ? void 0 : _t.fontFamily : fontFamily
    },
    buttonLabel1: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: ((_u = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel1) === null || _u === void 0 ? void 0 : _u.fontFamily) ? (_v = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel1) === null || _v === void 0 ? void 0 : _v.fontFamily : fontFamily,
      textCase: (_w = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel1) === null || _w === void 0 ? void 0 : _w.textCase
    },
    buttonLabel2: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: ((_x = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel2) === null || _x === void 0 ? void 0 : _x.fontFamily) ? (_y = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel2) === null || _y === void 0 ? void 0 : _y.fontFamily : fontFamily,
      textCase: (_z = overrides === null || overrides === void 0 ? void 0 : overrides.buttonLabel2) === null || _z === void 0 ? void 0 : _z.textCase
    },
    formLabel: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "16px",
      letterSpacing: "normal",
      fontFamily: ((_0 = overrides === null || overrides === void 0 ? void 0 : overrides.formLabel) === null || _0 === void 0 ? void 0 : _0.fontFamily) ? (_1 = overrides === null || overrides === void 0 ? void 0 : overrides.formLabel) === null || _1 === void 0 ? void 0 : _1.fontFamily : fontFamily,
      textCase: (_2 = overrides === null || overrides === void 0 ? void 0 : overrides.formLabel) === null || _2 === void 0 ? void 0 : _2.textCase
    },
    formError: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: "18px",
      letterSpacing: "normal",
      fontFamily: ((_3 = overrides === null || overrides === void 0 ? void 0 : overrides.formError) === null || _3 === void 0 ? void 0 : _3.fontFamily) ? (_4 = overrides === null || overrides === void 0 ? void 0 : overrides.formError) === null || _4 === void 0 ? void 0 : _4.fontFamily : fontFamily,
      textCase: (_5 = overrides === null || overrides === void 0 ? void 0 : overrides.formError) === null || _5 === void 0 ? void 0 : _5.textCase
    }
  };
};
var typography = function typography(kalturaTheme) {
  return {
    htmlFontSize: 16,
    fontFamily: kalturaTheme.typography.fontFamily,
    fontSize: kalturaTheme.typography.fontSize,
    fontWeightLight: kalturaTheme.typography.fontWeightLight,
    fontWeightRegular: kalturaTheme.typography.fontWeightRegular,
    fontWeightMedium: kalturaTheme.typography.fontWeightMedium,
    fontWeightBold: kalturaTheme.typography.fontWeightBold,
    h1: Object.assign(Object.assign({}, kalturaTheme.typography.heading1), {
      marginTop: kalturaTheme.typography.heading1.topBottomMargins,
      marginBottom: kalturaTheme.typography.heading1.topBottomMargins
    }),
    h2: Object.assign(Object.assign({}, kalturaTheme.typography.heading2), {
      marginTop: kalturaTheme.typography.heading2.topBottomMargins,
      marginBottom: kalturaTheme.typography.heading2.topBottomMargins
    }),
    h3: Object.assign(Object.assign({}, kalturaTheme.typography.heading3), {
      marginTop: kalturaTheme.typography.heading3.topBottomMargins,
      marginBottom: kalturaTheme.typography.heading3.topBottomMargins
    }),
    h4: Object.assign(Object.assign({}, kalturaTheme.typography.heading4), {
      marginTop: kalturaTheme.typography.heading4.topBottomMargins,
      marginBottom: kalturaTheme.typography.heading4.topBottomMargins
    }),
    h5: Object.assign(Object.assign({}, kalturaTheme.typography.heading5), {
      marginTop: kalturaTheme.typography.heading5.topBottomMargins,
      marginBottom: kalturaTheme.typography.heading5.topBottomMargins
    }),
    body1: Object.assign({}, kalturaTheme.typography.body1),
    body1Highlight: Object.assign({}, kalturaTheme.typography.body1Highlight),
    body2: Object.assign({}, kalturaTheme.typography.body2),
    body2Highlight: Object.assign({}, kalturaTheme.typography.body2Highlight),
    button: Object.assign(Object.assign({}, kalturaTheme.typography.buttonLabel1), {
      textTransform: kalturaTheme.typography.buttonLabel1.textCase
    }),
    buttonLabel1: Object.assign(Object.assign({}, kalturaTheme.typography.buttonLabel1), {
      textTransform: kalturaTheme.typography.buttonLabel1.textCase
    }),
    buttonLabel2: Object.assign(Object.assign({}, kalturaTheme.typography.buttonLabel2), {
      textTransform: kalturaTheme.typography.buttonLabel2.textCase
    }),
    formLabel: Object.assign(Object.assign({}, kalturaTheme.typography.formLabel), {
      textTransform: kalturaTheme.typography.formLabel.textCase
    }),
    formError: Object.assign(Object.assign({}, kalturaTheme.typography.formError), {
      textTransform: kalturaTheme.typography.formError.textCase
    })
  };
};

var defaultKalturaDarkTones = {
  tone1: '#FFFFFF',
  tone2: '#CCCCCC',
  tone3: '#999999',
  tone4: '#666666',
  tone5: '#525252',
  tone6: '#383838',
  tone7: '#212121',
  tone8: '#000000',
  surfaces: {
    background: '#121212',
    paper: '#242424',
    elevated: '#333333',
    protection: '#3D3D3D' // TODO seems to be added by mistake - condsider to remove

  },
  backdrop: {
    color: '#222222',
    opacity: 0.6
  }
};

var wellKnownSymbol$a = wellKnownSymbol$c;

var TO_STRING_TAG$2 = wellKnownSymbol$a('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$5 = isCallable$f;
var classofRaw = classofRaw$1;
var wellKnownSymbol$9 = wellKnownSymbol$c;

var TO_STRING_TAG$1 = wellKnownSymbol$9('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$5(O.callee) ? 'Arguments' : result;
};

var classof$4 = classof$5;

var toString$7 = function (argument) {
  if (classof$4(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var requireObjectCoercible$3 = requireObjectCoercible$6;
var toString$6 = toString$7;
var whitespaces$1 = whitespaces$2;

var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = toString$6(requireObjectCoercible$3($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var global$2 = global$d;
var fails$7 = fails$e;
var toString$5 = toString$7;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = global$2.parseInt;
var Symbol$1 = global$2.Symbol;
var ITERATOR$5 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0[Xx]/;
var FORCED$1 = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$5 && !fails$7(function () { $parseInt$1(Object(ITERATOR$5)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$1 ? function parseInt(string, radix) {
  var S = trim(toString$5(string));
  return $parseInt$1(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt$1;

var $$8 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$8({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

var classof$3 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof$3(argument) == 'Array';
};

var fails$6 = fails$e;
var isCallable$4 = isCallable$f;
var classof$2 = classof$5;
var getBuiltIn$1 = getBuiltIn$5;
var inspectSource = inspectSource$3;

var empty = [];
var construct = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable$4(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable$4(argument)) return false;
  switch (classof$2(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$3 = !construct || fails$6(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var toPropertyKey = toPropertyKey$3;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;

var createProperty$2 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule$1.f(object, propertyKey, createPropertyDescriptor$1(0, value));
  else object[propertyKey] = value;
};

var fails$5 = fails$e;
var wellKnownSymbol$8 = wellKnownSymbol$c;
var V8_VERSION = engineV8Version;

var SPECIES$2 = wellKnownSymbol$8('species');

var arrayMethodHasSpeciesSupport$2 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails$5(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$2] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$7 = _export;
var isArray$1 = isArray$2;
var isConstructor$2 = isConstructor$3;
var isObject$1 = isObject$7;
var toAbsoluteIndex = toAbsoluteIndex$2;
var toLength$3 = toLength$5;
var toIndexedObject = toIndexedObject$4;
var createProperty$1 = createProperty$2;
var wellKnownSymbol$7 = wellKnownSymbol$c;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$2;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('slice');

var SPECIES$1 = wellKnownSymbol$7('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$$7({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength$3(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray$1(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor$2(Constructor) && (Constructor === Array || isArray$1(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$1(Constructor)) {
        Constructor = Constructor[SPECIES$1];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty$1(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var valueOf = 1.0.valueOf;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = function (value) {
  return valueOf.call(value);
};

var toInteger$2 = toInteger$5;
var toString$4 = toString$7;
var requireObjectCoercible$2 = requireObjectCoercible$6;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$4(requireObjectCoercible$2(this));
  var result = '';
  var n = toInteger$2(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$6 = _export;
var toInteger$1 = toInteger$5;
var thisNumberValue = thisNumberValue$1;
var repeat$1 = stringRepeat;
var fails$4 = fails$e;

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat$1.call('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails$4(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$6({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger$1(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat$1.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat$1.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

// https://github.com/tc39/proposal-string-pad-start-end
var toLength$2 = toLength$5;
var toString$3 = toString$7;
var repeat = stringRepeat;
var requireObjectCoercible$1 = requireObjectCoercible$6;

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod$2 = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString$3(requireObjectCoercible$1($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString$3(fillString);
    var intMaxLength = toLength$2(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

var stringPad = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod$2(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod$2(true)
};

// https://github.com/zloirock/core-js/issues/280
var userAgent = engineUserAgent;

var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

var $$5 = _export;
var $padStart = stringPad.start;
var WEBKIT_BUG = stringPadWebkitBug;

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$$5({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var redefine$4 = redefine$6.exports;

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING$1 = 'toString';
var nativeDateToString = DatePrototype[TO_STRING$1];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) != INVALID_DATE) {
  redefine$4(DatePrototype, TO_STRING$1, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$1 = classof$5;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$1(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine$3 = redefine$6.exports;
var toString$2 = objectToString;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine$3(Object.prototype, 'toString', toString$2, { unsafe: true });
}

var anObject$7 = anObject$a;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$7(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var redefine$2 = redefine$6.exports;
var anObject$6 = anObject$a;
var $toString = toString$7;
var fails$3 = fails$e;
var flags = regexpFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$3(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$2(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$6(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var hexToHSL = function hexToHSL(hex) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  var normalizedR = r / 255;
  var normalizedG = g / 255;
  var normalizedB = b / 255;
  var cMin = Math.min(normalizedR, normalizedG, normalizedB);
  var cMax = Math.max(normalizedR, normalizedG, normalizedB);
  var delta = cMax - cMin;
  var hue = 0;
  var saturation = 0;
  var lightness = (cMax + cMin) / 2;

  if (delta !== 0) {
    if (cMax === normalizedR) {
      hue = (normalizedG - normalizedB) / delta % 6;
    } else if (cMax === normalizedG) {
      hue = (normalizedB - normalizedR) / delta + 2;
    } else {
      hue = (normalizedR - normalizedG) / delta + 4;
    }
  }

  hue = Math.round(hue * 60);

  if (hue < 0) {
    hue += 360;
  }

  saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));
  saturation = +(saturation * 100).toFixed(1);
  lightness = +(lightness * 100).toFixed(1);
  var hsl = [hue, saturation, lightness];
  return hsl;
};
var HSLToHex = function HSLToHex(h, s, l) {
  s /= 100;
  l /= 100;
  var c = (1 - Math.abs(2 * l - 1)) * s;
  var x = c * (1 - Math.abs(h / 60 % 2 - 1));
  var m = l - c / 2;
  var r = 0;
  var g = 0;
  var b = 0;

  if (h >= 0 && h < 60) {
    r = c;
    g = x;
  } else if (h >= 60 && h < 120) {
    r = x;
    g = c;
  } else if (h >= 120 && h < 180) {
    g = c;
    b = x;
  } else if (h >= 180 && h < 240) {
    g = x;
    b = c;
  } else if (h >= 240 && h < 300) {
    r = x;
    b = c;
  } else if (h >= 300 && h < 360) {
    r = c;
    b = x;
  }

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);
  var hex = "#" + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0');
  return hex;
};
var hexToRGB = function hexToRGB(h) {
  var r = 0;
  var g = 0;
  var b = 0;

  if (h.length === 4) {
    r = parseInt(h[1] + h[1], 16);
    g = parseInt(h[2] + h[2], 16);
    b = parseInt(h[3] + h[3], 16);
  } else if (h.length === 7) {
    r = parseInt(h.slice(1, 3), 16);
    g = parseInt(h.slice(3, 5), 16);
    b = parseInt(h.slice(5, 7), 16);
  }

  var rgb = [r, g, b];
  return rgb;
};

var _ERoundnessToNumberMa, _colorTypeLightnessVa;

var CURRENT_EDITOR_VERSION = 1;
var ERoundness;

(function (ERoundness) {
  ERoundness["Sharp"] = "Sharp edges";
  ERoundness["SlightlyRounded"] = "Slightly rounded";
  ERoundness["VeryRounded"] = "Rounded";
})(ERoundness || (ERoundness = {}));

var ERoundnessToNumberMapping = (_ERoundnessToNumberMa = {}, _ERoundnessToNumberMa[ERoundness.Sharp] = 0, _ERoundnessToNumberMa[ERoundness.SlightlyRounded] = 4, _ERoundnessToNumberMa[ERoundness.VeryRounded] = 8, _ERoundnessToNumberMa);
var NumberToERoundnessMapping = {
  0: ERoundness.Sharp,
  4: ERoundness.SlightlyRounded,
  8: ERoundness.VeryRounded
};
var EColorScheme;

(function (EColorScheme) {
  EColorScheme["Neutral"] = "Neutral";
  EColorScheme["Monochrome"] = "Monochrome";
  EColorScheme["Custom"] = "Custom";
})(EColorScheme || (EColorScheme = {}));

var defaultColor = '#006EFA';
var defaultThemeMode = 'dark';
var defaultColorScheme = EColorScheme.Neutral;
var defaultRoundness = ERoundness.SlightlyRounded;
var defaultFontFamily = 'Lato, Helvetica Neue, Segoe UI, sans-serif';
var defaultThemeEditorTokens = {
  meta: {
    version: 2
  },
  brandColor: defaultColor,
  mode: defaultThemeMode,
  colorScheme: defaultColorScheme,
  fontFamily: defaultFontFamily,
  webFontUrl: '',
  roundness: defaultRoundness
};
var EThemeColorType;

(function (EThemeColorType) {
  EThemeColorType["Tone1"] = "Tone1";
  EThemeColorType["Tone2"] = "Tone2";
  EThemeColorType["Tone3"] = "Tone3";
  EThemeColorType["Tone4"] = "Tone4";
  EThemeColorType["Tone5"] = "Tone5";
  EThemeColorType["Tone6"] = "Tone6";
  EThemeColorType["Tone7"] = "Tone7";
  EThemeColorType["Tone8"] = "Tone8";
  EThemeColorType["SurfaceBackground"] = "SurfaceBackground";
  EThemeColorType["SurfacePaper"] = "SurfacePaper";
  EThemeColorType["SurfaceElevated"] = "SurfaceElevated";
})(EThemeColorType || (EThemeColorType = {}));

var EThemeHightContrastColorType;

(function (EThemeHightContrastColorType) {
  EThemeHightContrastColorType["Tone1"] = "Tone1HighContrast";
  EThemeHightContrastColorType["Tone2"] = "Tone2HighContrast";
  EThemeHightContrastColorType["Tone3"] = "Tone3HighContrast";
  EThemeHightContrastColorType["Tone4"] = "Tone4HighContrast";
  EThemeHightContrastColorType["Tone5"] = "Tone5HighContrast";
  EThemeHightContrastColorType["Tone6"] = "Tone6HighContrast";
  EThemeHightContrastColorType["Tone7"] = "Tone7HighContrast";
  EThemeHightContrastColorType["Tone8"] = "Tone8HighContrast";
  EThemeHightContrastColorType["SurfaceBackground"] = "SurfaceBackgroundHighContrast";
  EThemeHightContrastColorType["SurfacePaper"] = "SurfacePaperHighContrast";
  EThemeHightContrastColorType["SurfaceElevated"] = "SurfaceElevatedHighContrast";
})(EThemeHightContrastColorType || (EThemeHightContrastColorType = {}));

var EThemeEditorColorType;

(function (EThemeEditorColorType) {
  EThemeEditorColorType["SchemaOptionTone1"] = "SchemaOptionTone1";
  EThemeEditorColorType["SchemaOptionTone2"] = "SchemaOptionTone2";
  EThemeEditorColorType["SchemaOptionTone3"] = "SchemaOptionTone3";
  EThemeEditorColorType["SchemaOptionTone4"] = "SchemaOptionTone4";
})(EThemeEditorColorType || (EThemeEditorColorType = {})); //NOTE: these values are constant and come from the designers


var colorTypeLightnessValuesMapping = (_colorTypeLightnessVa = {}, _colorTypeLightnessVa[EThemeColorType.SurfaceBackground] = [100, 7], _colorTypeLightnessVa[EThemeColorType.SurfacePaper] = [96, 14], _colorTypeLightnessVa[EThemeColorType.SurfaceElevated] = [100, 20], _colorTypeLightnessVa[EThemeColorType.Tone1] = [20, 100], _colorTypeLightnessVa[EThemeColorType.Tone2] = [44, 80], _colorTypeLightnessVa[EThemeColorType.Tone3] = [53, 60], _colorTypeLightnessVa[EThemeColorType.Tone4] = [74, 40], _colorTypeLightnessVa[EThemeColorType.Tone5] = [85, 32], _colorTypeLightnessVa[EThemeColorType.Tone6] = [92, 22], _colorTypeLightnessVa[EThemeColorType.Tone7] = [96, 13], _colorTypeLightnessVa[EThemeColorType.Tone8] = [100, 0], _colorTypeLightnessVa[EThemeEditorColorType.SchemaOptionTone1] = [20, 92], _colorTypeLightnessVa[EThemeEditorColorType.SchemaOptionTone2] = [53, 60], _colorTypeLightnessVa[EThemeEditorColorType.SchemaOptionTone3] = [85, 40], _colorTypeLightnessVa[EThemeEditorColorType.SchemaOptionTone4] = [92, 26], _colorTypeLightnessVa[EThemeHightContrastColorType.SurfaceBackground] = [100, 0], _colorTypeLightnessVa[EThemeHightContrastColorType.SurfacePaper] = [100, 0], _colorTypeLightnessVa[EThemeHightContrastColorType.SurfaceElevated] = [100, 10], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone1] = [0, 100], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone2] = [0, 100], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone3] = [0, 100], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone4] = [20, 80], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone5] = [92, 24], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone6] = [92, 22], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone7] = [96, 13], _colorTypeLightnessVa[EThemeHightContrastColorType.Tone8] = [100, 0], _colorTypeLightnessVa);

var getLightnessForMode = function getLightnessForMode(mode, lightValue, darkValue) {
  return mode === 'light' ? lightValue : mode === 'dark' ? darkValue : 100;
};
var getColorLightnessForMode = function getColorLightnessForMode(mode, colorType) {
  var lightnessValues = colorTypeLightnessValuesMapping[colorType];
  return getLightnessForMode(mode, lightnessValues[0], lightnessValues[1]);
};
var getSchemeParameters = function getSchemeParameters(scheme, hue, saturation) {
  var adjustedSaturation = saturation;

  switch (scheme) {
    case EColorScheme.Neutral:
      adjustedSaturation = 0;
      break;

    case EColorScheme.Monochrome:
      adjustedSaturation = saturation !== 0 ? 24 : 0;
      break;

    case EColorScheme.Custom:
      adjustedSaturation = saturation;
      break;
  }

  return {
    hue: hue,
    saturation: adjustedSaturation
  };
};
var getPrimaryFromTokens = function getPrimaryFromTokens(color) {
  var hsl = hexToHSL(color);
  var hue = hsl[0];
  var saturation = hsl[1];
  var lightness = hsl[2]; //processing primary colors lightness

  var darkLightness = lightness > 10 ? lightness - 10 : 0;
  var lightLightness = lightness < 90 ? lightness + 10 : 100; //processing contrast text

  var rgb = hexToRGB(color);
  var luminance = (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
  return {
    dark: HSLToHex(hue, saturation, darkLightness),
    main: HSLToHex(hue, saturation, lightness),
    light: HSLToHex(hue, saturation, lightLightness),
    contrastText: luminance > 0.5 ? '#000000' : '#ffffff'
  };
};
var getColorFromTokens = function getColorFromTokens(tokens, colorType) {
  //deciding which color to use
  var color = tokens.colorScheme === EColorScheme.Custom ? tokens.otherColor || tokens.brandColor : tokens.brandColor;
  var hsl = hexToHSL(color);
  var hue = hsl[0];
  var saturation = hsl[1];
  var schemeParameters = getSchemeParameters(tokens.colorScheme, hue, saturation);
  hue = schemeParameters.hue;
  saturation = schemeParameters.saturation;
  var lightness = getColorLightnessForMode(tokens.mode, colorType);
  return HSLToHex(hue, saturation, lightness);
};
var getSurfacesProtection = function getSurfacesProtection(tokens) {
  //deciding which color to use
  var color = tokens.colorScheme === EColorScheme.Custom ? tokens.headerColor || tokens.brandColor : tokens.brandColor;
  var hsl = hexToHSL(color);
  var hue = hsl[0];
  var saturation = hsl[1];
  var lightness = hsl[2];
  var schemeParameters = getSchemeParameters(tokens.colorScheme, hue, saturation);
  hue = schemeParameters.hue;
  saturation = schemeParameters.saturation;
  lightness = tokens.colorScheme === EColorScheme.Custom ? lightness : 24;
  return HSLToHex(hue, saturation, lightness);
};

var TranslucentColors = {
  main: "#fff",
  dark: "#000",
  light: "#fff",
  contrastText: "#fff",
  commonBlack: '#000000',
  commonWhite: '#FFFFFF'
};
var contrastThreshold = 3;
var generateKalturaPalette = function generateKalturaPalette(paletteMode) {
  var modeColors = paletteMode === "light" ? defaultKalturaLightTones : defaultKalturaDarkTones;
  return Object.assign({
    primary: {
      light: "#4798FF",
      main: "#006EFA",
      dark: "#004CAD",
      contrastText: "#ffffff"
    },
    secondary: {
      light: "#FFC34C",
      main: "#FFAA00",
      dark: "#B37700",
      contrastText: "#ffffff"
    },
    danger: {
      light: "#EA6674",
      main: "#E12437",
      dark: "#A11624",
      contrastText: "#ffffff"
    },
    success: {
      light: "#31B551",
      main: "#217A37",
      dark: "#103C1B",
      contrastText: "#ffffff"
    },
    warning: {
      light: "#EF996B",
      main: "#E86925",
      dark: "#AF4912",
      contrastText: "#ffffff"
    },
    translucent: TranslucentColors,
    brand: {
      yellow: {
        main: "#FFCD00"
      }
    }
  }, modeColors);
};
var palette = function palette(_palette, mode) {
  return {
    background: {
      paper: _palette.surfaces.paper,
      "default": _palette.surfaces.background
    },
    mode: mode,
    text: {
      primary: _palette.tone1,
      secondary: alpha(_palette.tone1, 0.7),
      disabled: alpha(_palette.tone1, 0.5)
    },
    grey: {
      "100": _palette.tone1,
      "200": _palette.tone2,
      "300": _palette.tone3,
      "400": _palette.tone4,
      "500": _palette.tone5,
      "600": _palette.tone6,
      "700": _palette.tone7,
      "800": _palette.tone8
    },
    primary: _palette.primary,
    secondary: _palette.secondary,
    warning: _palette.warning,
    success: _palette.success,
    divider: "rgba(0, 0, 0, 0.25)",
    tonalOffset: 0.3,
    translucent: {
      main: _palette.translucent.commonBlack
    }
  };
};

var augmentColor = function augmentColor(color) {
  return {
    light: color.light ? color.light : lighten(color.main, 0.3),
    main: color.main,
    dark: color.dark ? color.dark : darken(color.main, 0.3),
    contrastText: color.contrastText ? color.contrastText : getContrastText(color.main)
  };
};

var getContrastText = function getContrastText(background) {
  var ratio = contrast.ratio(background, defaultKalturaDarkTones.tone1);
  var contrastText = ratio >= contrastThreshold ? defaultKalturaDarkTones.tone1 : defaultKalturaLightTones.tone1;

  if (process.env.NODE_ENV !== "production") {
    var ratioSanity = contrast.ratio(background, contrastText);

    if (ratioSanity < 3) {
      console.error("Kaltura-DS: The calculated ratio between text " + contrastText + " on " + background + " background " + ("is " + contrast + ":1 and is below the WCAG recommended absolute minimum contrast ratio of 3:1."));
    }
  }

  return contrastText;
};

var augmentPalette = function augmentPalette(palette, overridePalette) {
  return Object.assign(Object.assign({}, palette), {
    primary: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.primary) ? overridePalette.primary : palette.primary),
    secondary: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.secondary) ? overridePalette.secondary : palette.secondary),
    warning: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.warning) ? overridePalette.warning : palette.warning),
    success: augmentColor((overridePalette === null || overridePalette === void 0 ? void 0 : overridePalette.success) ? overridePalette.success : palette.success)
  });
};
/**
 * apply high-contrast values to a given kaltura pallete
 */

var applyHighContrastKalturaPalette = function applyHighContrastKalturaPalette(paletteMode, palette) {
  var _a, _b, _c, _d;

  var defaultKalturaPalette = paletteMode === "light" ? defaultKalturaLightTones : defaultKalturaDarkTones;
  var highContrastPallete = Object.assign(Object.assign({}, palette), {
    tone1: getHighContrastColor(palette.tone1, paletteMode, EThemeHightContrastColorType.Tone1) || defaultKalturaPalette.tone1,
    tone2: getHighContrastColor(palette.tone2, paletteMode, EThemeHightContrastColorType.Tone2) || defaultKalturaPalette.tone2,
    tone3: getHighContrastColor(palette.tone3, paletteMode, EThemeHightContrastColorType.Tone3) || defaultKalturaPalette.tone3,
    tone4: getHighContrastColor(palette.tone4, paletteMode, EThemeHightContrastColorType.Tone4) || defaultKalturaPalette.tone4,
    tone5: getHighContrastColor(palette.tone5, paletteMode, EThemeHightContrastColorType.Tone5) || defaultKalturaPalette.tone5,
    tone6: getHighContrastColor(palette.tone6, paletteMode, EThemeHightContrastColorType.Tone6) || defaultKalturaPalette.tone6,
    tone7: getHighContrastColor(palette.tone7, paletteMode, EThemeHightContrastColorType.Tone7) || defaultKalturaPalette.tone7,
    tone8: getHighContrastColor(palette.tone8, paletteMode, EThemeHightContrastColorType.Tone8) || defaultKalturaPalette.tone8,
    surfaces: {
      background: getHighContrastColor((_a = palette.surfaces) === null || _a === void 0 ? void 0 : _a.background, paletteMode, EThemeHightContrastColorType.SurfaceBackground) || defaultKalturaPalette.surfaces.background,
      paper: getHighContrastColor((_b = palette.surfaces) === null || _b === void 0 ? void 0 : _b.paper, paletteMode, EThemeHightContrastColorType.SurfacePaper) || defaultKalturaPalette.surfaces.paper,
      elevated: getHighContrastColor((_c = palette.surfaces) === null || _c === void 0 ? void 0 : _c.elevated, paletteMode, EThemeHightContrastColorType.SurfaceElevated) || defaultKalturaPalette.surfaces.elevated,
      protection: ((_d = palette.surfaces) === null || _d === void 0 ? void 0 : _d.protection) || defaultKalturaPalette.surfaces.protection
    }
  });
  return highContrastPallete;
};
/**
 * apply high-contrast value to a given color
 */

var getHighContrastColor = function getHighContrastColor(color, mode, colorType) {
  if (!color) {
    return color;
  } // get hue and saturation from the given color


  var hsl = hexToHSL(color);
  var hue = hsl[0];
  var saturation = hsl[1]; // change lightness to high-contrast value (different for each color type)

  var lightness = getColorLightnessForMode(mode, colorType); // re-calculate the color with the high-contrast lightness

  return HSLToHex(hue, saturation, lightness);
};

function createMuiTheme(kalturaTheme) {
  var theme = {
    breakpoints: breakpoints(kalturaTheme.breakpoints),
    typography: typography(kalturaTheme),
    palette: palette(kalturaTheme.palette, kalturaTheme.mode),
    transitions: {
      easing: {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
      },
      duration: {
        shortest: 150,
        shorter: 200,
        "short": 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
      }
    },
    zIndex: {
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500
    },
    spacing: function spacing(factor) {
      return 0.5 * factor + "rem";
    },
    kaltura: Object.assign({}, kalturaTheme)
  }; // create the theme.

  return createTheme(Object.assign(Object.assign({}, theme), {
    palette: Object.assign(Object.assign({}, theme.palette), {
      translucent: {
        main: kalturaTheme.palette.translucent.commonBlack
      }
    }),
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true // No more ripple, on the whole application

        }
      },
      MuiScopedCssBaseline: {
        styleOverrides: {
          root: {
            backgroundColor: "unset"
          }
        }
      }
    }
  }));
}

var defaultKalturaElevations = {
  low: "none",
  medium: "0px 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 30px -8px rgba(0, 0, 0, 0.2)",
  high: "0px 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 8px 60px -16px rgba(0, 0, 0, 0.2)"
};

var defaultKalturaShape = {
  roundness1: 4,
  roundness2: 8,
  roundness3: 16
};

var createKalturaTheme = function createKalturaTheme(options) {
  if (options === void 0) {
    options = {
      mode: 'light',
      overrides: {}
    };
  }

  var _options = options,
      _options$mode = _options.mode,
      mode = _options$mode === void 0 ? 'light' : _options$mode,
      _options$overrides = _options.overrides,
      overrides = _options$overrides === void 0 ? {} : _options$overrides;
  var palette = deepmerge(generateKalturaPalette(mode), deepmerge((overrides === null || overrides === void 0 ? void 0 : overrides.palette) || {}, {
    translucent: TranslucentColors
  }));
  return {
    breakpoints: deepmerge(defaultKalturaBreakpoint, (overrides === null || overrides === void 0 ? void 0 : overrides.breakpoints) || {}),
    elevations: deepmerge(defaultKalturaElevations, (overrides === null || overrides === void 0 ? void 0 : overrides.elevations) || {}),
    palette: augmentPalette(palette, overrides === null || overrides === void 0 ? void 0 : overrides.palette),
    shape: deepmerge(defaultKalturaShape, (overrides === null || overrides === void 0 ? void 0 : overrides.shape) || {}),
    typography: deepmerge(generateKalturaTypography(overrides === null || overrides === void 0 ? void 0 : overrides.typography), Object.assign({
      color: palette.tone1
    }, overrides === null || overrides === void 0 ? void 0 : overrides.typography) || {}),
    mode: mode
  };
};

var getThemeEditorColorSchemeTones = function getThemeEditorColorSchemeTones(mode, colorScheme, color) {
  var hsl = hexToHSL(color);
  var hue = hsl[0];
  var saturation = hsl[1];
  var schemeParameters = getSchemeParameters(colorScheme, hue, saturation);
  hue = schemeParameters.hue;
  saturation = schemeParameters.saturation;
  var lightnessTone1 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone1);
  var lightnessTone2 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone2);
  var lightnessTone3 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone3);
  var lightnessTone4 = getColorLightnessForMode(mode, EThemeEditorColorType.SchemaOptionTone4);
  var schemeSaturation = colorScheme === EColorScheme.Neutral ? 0 : colorScheme === EColorScheme.Monochrome ? 24 : saturation;
  return {
    tone1: HSLToHex(hue, schemeSaturation, lightnessTone1),
    tone2: HSLToHex(hue, schemeSaturation, lightnessTone2),
    tone3: HSLToHex(hue, schemeSaturation, lightnessTone3),
    tone4: HSLToHex(hue, schemeSaturation, lightnessTone4)
  };
};
var isThemeEditorTokensV1 = function isThemeEditorTokensV1(obj) {
  var _a, _b, _c;

  return obj && ((_a = obj.meta) === null || _a === void 0 ? void 0 : _a.version) && typeof ((_b = obj.meta) === null || _b === void 0 ? void 0 : _b.version) == 'number' && ((_c = obj.meta) === null || _c === void 0 ? void 0 : _c.version) === 1;
};
var isThemeEditorTokensV2 = function isThemeEditorTokensV2(obj) {
  var _a, _b, _c;

  return obj && ((_a = obj.meta) === null || _a === void 0 ? void 0 : _a.version) && typeof ((_b = obj.meta) === null || _b === void 0 ? void 0 : _b.version) == 'number' && ((_c = obj.meta) === null || _c === void 0 ? void 0 : _c.version) === 2;
};
var isThemeEditorTokens = function isThemeEditorTokens(obj) {
  var _a, _b;

  return obj && ((_a = obj.meta) === null || _a === void 0 ? void 0 : _a.version) && typeof ((_b = obj.meta) === null || _b === void 0 ? void 0 : _b.version) == 'number';
}; //use this method from outside if needed to load the editor with a certain mode

var getDefaultThemeEditorTokens = function getDefaultThemeEditorTokens(mode) {
  return Object.assign(Object.assign({}, defaultThemeEditorTokens), {
    mode: mode,
    meta: {
      version: CURRENT_EDITOR_VERSION
    }
  });
};

var aCallable$1 = aCallable$3;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aCallable$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var isArray = isArray$2;
var isConstructor$1 = isConstructor$3;
var isObject = isObject$7;
var wellKnownSymbol$6 = wellKnownSymbol$c;

var SPECIES = wellKnownSymbol$6('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$1(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind$1 = functionBindContext;
var IndexedObject = indexedObject;
var toObject$3 = toObject$6;
var toLength$1 = toLength$5;
var arraySpeciesCreate = arraySpeciesCreate$1;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$3($this);
    var self = IndexedObject(O);
    var boundFunction = bind$1(callbackfn, that, 3);
    var length = toLength$1(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

var $$4 = _export;
var $filter = arrayIteration.filter;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$2;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$4({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var anObject$5 = anObject$a;
var getMethod$1 = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$5(iterator);
  try {
    innerResult = getMethod$1(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = innerResult.call(iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$5(innerResult);
  return value;
};

var anObject$4 = anObject$a;
var iteratorClose = iteratorClose$1;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$4(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var iterators = {};

var wellKnownSymbol$5 = wellKnownSymbol$c;
var Iterators$3 = iterators;

var ITERATOR$4 = wellKnownSymbol$5('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$3.Array === it || ArrayPrototype[ITERATOR$4] === it);
};

var classof = classof$5;
var getMethod = getMethod$3;
var Iterators$2 = iterators;
var wellKnownSymbol$4 = wellKnownSymbol$c;

var ITERATOR$3 = wellKnownSymbol$4('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR$3)
    || getMethod(it, '@@iterator')
    || Iterators$2[classof(it)];
};

var aCallable = aCallable$3;
var anObject$3 = anObject$a;
var getIteratorMethod$1 = getIteratorMethod$2;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject$3(iteratorMethod.call(argument));
  throw TypeError(String(argument) + ' is not iterable');
};

var bind = functionBindContext;
var toObject$2 = toObject$6;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var isConstructor = isConstructor$3;
var toLength = toLength$5;
var createProperty = createProperty$2;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$2(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = IS_CONSTRUCTOR ? new this(length) : Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var wellKnownSymbol$3 = wellKnownSymbol$c;

var ITERATOR$2 = wellKnownSymbol$3('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var $$3 = _export;
var from = arrayFrom;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$$3({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});

var toInteger = toInteger$5;
var toString$1 = toString$7;
var requireObjectCoercible = requireObjectCoercible$6;

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$1(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var DESCRIPTORS = descriptors;
var definePropertyModule = objectDefineProperty;
var anObject$2 = anObject$a;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$2(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn = getBuiltIn$5;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$1 = anObject$a;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$1(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var fails$2 = fails$e;

var correctPrototypeGetter = !fails$2(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$1 = has$9;
var isCallable$3 = isCallable$f;
var toObject$1 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (has$1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$3(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};

var fails$1 = fails$e;
var isCallable$2 = isCallable$f;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$1 = redefine$6.exports;
var wellKnownSymbol$2 = wellKnownSymbol$c;

var ITERATOR$1 = wellKnownSymbol$2('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$1(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$1].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$2(IteratorPrototype$2[ITERATOR$1])) {
  redefine$1(IteratorPrototype$2, ITERATOR$1, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty = objectDefineProperty.f;
var has = has$9;
var wellKnownSymbol$1 = wellKnownSymbol$c;

var TO_STRING_TAG = wellKnownSymbol$1('toStringTag');

var setToStringTag$2 = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$4;
var setToStringTag$1 = setToStringTag$2;
var Iterators$1 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$1[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$1 = isCallable$f;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument === 'object' || isCallable$1(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var anObject = anObject$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$2 = _export;
var FunctionName = functionName;
var isCallable = isCallable$f;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var redefine = redefine$6.exports;
var wellKnownSymbol = wellKnownSymbol$c;
var Iterators = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};

var charAt = stringMultibyte.charAt;
var toString = toString$7;
var InternalStateModule = internalState;
var defineIterator = defineIterator$1;

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var generateKalturaPaletteFromTokens = function generateKalturaPaletteFromTokens(tokens) {
  var primary = getPrimaryFromTokens(tokens.brandColor);
  return {
    primary: {
      dark: primary.dark,
      main: primary.main,
      light: primary.light,
      contrastText: primary.contrastText
    },
    secondary: {
      dark: primary.dark,
      main: primary.main,
      light: primary.light,
      contrastText: primary.contrastText
    },
    tone1: getColorFromTokens(tokens, EThemeColorType.Tone1),
    tone2: getColorFromTokens(tokens, EThemeColorType.Tone2),
    tone3: getColorFromTokens(tokens, EThemeColorType.Tone3),
    tone4: getColorFromTokens(tokens, EThemeColorType.Tone4),
    tone5: getColorFromTokens(tokens, EThemeColorType.Tone5),
    tone6: getColorFromTokens(tokens, EThemeColorType.Tone6),
    tone7: getColorFromTokens(tokens, EThemeColorType.Tone7),
    tone8: getColorFromTokens(tokens, EThemeColorType.Tone8),
    surfaces: {
      background: getColorFromTokens(tokens, EThemeColorType.SurfaceBackground),
      paper: getColorFromTokens(tokens, EThemeColorType.SurfacePaper),
      elevated: getColorFromTokens(tokens, EThemeColorType.SurfaceElevated),
      protection: getSurfacesProtection(tokens)
    }
  };
};

var generateKalturaTypographyFromTokens = function generateKalturaTypographyFromTokens(tokens) {
  return {
    fontFamily: tokens.fontFamily,
    webFontUrl: tokens.webFontUrl,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    lineHeight: 'auto',
    color: defaultKalturaLightTones.tone1,
    heading1: {
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.0417,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '2rem'
    },
    heading2: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.0625,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '1rem'
    },
    heading3: {
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.084,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading4: {
      fontWeight: 700,
      fontSize: "1.25rem",
      lineHeight: 1.1,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '0.5rem'
    },
    heading5: {
      fontWeight: 700,
      fontSize: "1.15rem",
      lineHeight: 1.11,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily,
      topBottomMargins: '0.25rem'
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.3125,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    body1Highlight: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: 1.3125,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.286,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    body2Highlight: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: 1.286,
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    buttonLabel1: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    buttonLabel2: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: "initial",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    formLabel: {
      fontWeight: 700,
      fontSize: "0.875rem",
      lineHeight: "16px",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    },
    formError: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: "18px",
      letterSpacing: "normal",
      fontFamily: tokens.fontFamily
    }
  };
};

var generateEditorThemeFromTokensV2 = function generateEditorThemeFromTokensV2(tokens) {
  var kalturaPaletteFromTokens = generateKalturaPaletteFromTokens(tokens);
  return {
    breakpoints: defaultKalturaBreakpoint,
    elevations: defaultKalturaElevations,
    palette: deepmerge(generateKalturaPalette(tokens.mode), kalturaPaletteFromTokens),
    shape: deepmerge(defaultKalturaShape, Object.assign(Object.assign({}, defaultKalturaShape), {
      roundness1: ERoundnessToNumberMapping[tokens.roundness]
    })),
    typography: deepmerge(generateKalturaTypography(), generateKalturaTypographyFromTokens(tokens)),
    mode: tokens.mode
  };
};

function addFontUrl(tokens) {
  var _a, _b;

  if ((_b = (_a = tokens.typography) === null || _a === void 0 ? void 0 : _a.webFontUrl) === null || _b === void 0 ? void 0 : _b.length) {
    try {
      var fontUrl = tokens.typography.webFontUrl; // check if the link was already added

      var links = document.getElementsByTagName('link'); // get all document links as HTMLCollection

      var previousLinks = Array.from(links).filter(function (tag) {
        return tag.title === 'kaltura-ds-custom-font' && tag.href === fontUrl;
      }); // if the link was not added yet - add it to the document header

      if (previousLinks.length === 0) {
        var link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.title = 'kaltura-ds-custom-font';
        link.href = fontUrl;
        document.head.appendChild(link);
      }
    } catch (e) {
      console.error("Error loading custom font: " + e.message);
    }
  }
}
function createKalturaThemeFromTokens(tokensOrMode) {
  var tokens;

  if (typeof tokensOrMode === 'object') {
    if (isThemeEditorTokensV2(tokensOrMode)) {
      tokens = Object.assign({}, tokensOrMode);
    } else {
      //version not supported
      return null;
    }
  } else {
    tokens = Object.assign(Object.assign({}, defaultThemeEditorTokens), {
      mode: tokensOrMode
    });
  }

  return generateEditorThemeFromTokensV2(tokens);
}
var createVersionedKalturaTheme = function createVersionedKalturaTheme(overrides) {
  if (isThemeEditorTokens(overrides) && !isThemeEditorTokensV1(overrides)) {
    //if editor tokens overrides and not v1 - create calculated kaltura theme (version handling inside)
    //if version not supported then kalturaTheme is null - fallback to kaltura v2 with default mode
    var kalturaTheme = createKalturaThemeFromTokens(overrides);
    return kalturaTheme ? kalturaTheme : createKalturaThemeFromTokens('dark');
  } else {
    //if legacy overrides - create legacy kaltura theme
    var legacyOverrides = overrides;
    return createKalturaTheme({
      mode: legacyOverrides.mode || 'light',
      overrides: legacyOverrides
    });
  }
};

var $$1 = _export;
var global$1 = global$d;

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$$1({ global: true }, {
  globalThis: global$1
});

var $ = _export;
var toObject = toObject$6;
var nativeKeys = objectKeys$2;
var fails = fails$e;

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});

var augmentHighContrastTheme = function augmentHighContrastTheme(kalturaTheme, highContrast) {
  // modify override colors and surface for high-contrast
  var paletteOverrides = highContrast ? applyHighContrastKalturaPalette(kalturaTheme.mode, kalturaTheme.palette) : kalturaTheme.palette;
  return Object.assign(Object.assign({}, kalturaTheme), {
    palette: paletteOverrides
  });
};

try {
  if (globalThis && process.env.STORYBOOK !== 'true') {
    // https://github.com/facebook/regenerator/issues/378#issuecomment-765141043
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    globalThis.regeneratorRuntime = undefined;
  }
} catch (e) {// ignore
}

var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$highContrast = _ref.highContrast,
      highContrast = _ref$highContrast === void 0 ? false : _ref$highContrast,
      scoped = _ref.scoped,
      _ref$injectFirst = _ref.injectFirst,
      injectFirst = _ref$injectFirst === void 0 ? true : _ref$injectFirst,
      children = _ref.children;
  var muiTheme = React.useMemo(function () {
    if (!overrides || !Object.keys(overrides).length) {
      //if no overrides - create default kaltura theme with mode
      return createMuiTheme(augmentHighContrastTheme(createKalturaTheme({
        mode: mode
      }), highContrast));
    } else {
      addFontUrl(overrides);
      return createMuiTheme(augmentHighContrastTheme(createVersionedKalturaTheme(overrides), highContrast));
    }
  }, [mode, overrides, highContrast]);
  return jsx(StylesProvider, Object.assign({
    injectFirst: injectFirst
  }, {
    children: jsx(ThemeProvider$1, Object.assign({
      theme: muiTheme
    }, {
      children: jsxs(ThemeProvider$2, Object.assign({
        theme: muiTheme
      }, {
        children: [!scoped && jsxs(Fragment, {
          children: [jsx(CssBaseline, {}, void 0), " ", children, " "]
        }, void 0), scoped && jsxs(ScopedCssBaseline, {
          children: [" ", children]
        }, void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
};
ThemeProvider.defaultProps = {
  injectFirst: true
};

var KalturaElevationToNumberMap = {
  'low': 0,
  'medium': 1,
  'high': 2
};
var VisibleFocusStyle = {
  outline: 'thin solid #0000FF',
  outlineOffset: '2px',
  boxShadow: '0 0 0 2px #FFFFFF, 0 0 0 3px #0000FF',
  borderRadius: '4px'
};

export { CURRENT_EDITOR_VERSION, EColorScheme, ERoundness, ERoundnessToNumberMapping, EThemeColorType, EThemeEditorColorType, EThemeHightContrastColorType, KalturaElevationToNumberMap, NumberToERoundnessMapping, ThemeProvider, VisibleFocusStyle, addFontUrl, augmentHighContrastTheme, colorTypeLightnessValuesMapping, createKalturaTheme, createKalturaThemeFromTokens, createMuiTheme, createVersionedKalturaTheme, defaultColor, defaultFontFamily, defaultThemeEditorTokens, getDefaultThemeEditorTokens, getThemeEditorColorSchemeTones, isThemeEditorTokens, isThemeEditorTokensV1, isThemeEditorTokensV2 };
